export const SEGMENT_DELAY_MS = 800;
export const COMPLETED_RESPONSE_REVEAL_INTERVAL_MS = 32;
export const COMPLETED_RESPONSE_REVEAL_MAX_CHUNK_SIZE = 10;
export const SCROLL_POSITION_TOLERANCE_PX = 1;
export const USER_MESSAGE_BOTTOM_OFFSET_PX = 125;
export const RESPONSE_PROGRESS_FADE_DURATION_MS = 350;
export const RESPONSE_PROGRESS_MAX_DELAY_MS = 8000;
export const RESPONSE_PROGRESS_MIN_DELAY_MS = 4000;
export const RESPONSE_PROGRESS_MESSAGES = [
  'Numerating…',
  'Connecting the dots…',
  'Considering the variables…',
  'Sampling a few ideas…',
  'Checking the details…',
  'Plotting a course…',
];
